const SERVICE = 2;
const LIMIT = 10; // page TOP / NEWS

const STATUS_CODES = {
  '401': '401',
  '403': '403',
  '404': '404',
  '429': '429',
  '500': '500',
  '512': '512',
  'sorry': 'sorry'
};

const DATE_FORMAT = {
  DATETIME_WITHOUT_SECONDS: "DD/MM/YYYY HH:mm",
  DATETIME: "DD/MM/YYYY HH:mm:ss",
  DATE: "DD/MM/YYYY",
  TIME: "HH:mm",
  SECONDDATETIME: "YYYY/MM/DD HH:mm:ss",
};

const this_required = "は必須項目です";
const ERROR_MESSAGE = {
  GENDER: "性別" + this_required,
  AGE: "年齢" + this_required,
  FIRST_NAME: "名" + this_required,
  LAST_NAME: "姓" + this_required,
  FIRST_NAME_PARTNER_KANA: "名（メイ）" + this_required,
  LAST_NAME_PARTNER_KANA: "性（セイ）" + this_required,
  FIRST_NAME_KANA: "セイ(カナ)" + this_required,
  FIRST_NAME_KANA_INVALID: "カタカナで入力してください",
  LAST_NAME_KANA: "メイ(カナ)" + this_required,
  LAST_NAME_KANA_INVALID: "カタカナで入力してください",
  PHONE: {
    REQUIRED: "携帯電話番号 " + this_required,
    INVALID: "数字10桁または11桁を入力してください",
  },
  LOGIN: {
    REQUIRED: "ログインID" + this_required,
    EXIST: "そのメールアドレスは既に存在しています",
    INVALID: "は、有効なメールアドレス形式で指定してください",
  },
  LOGIN_CONFIRMATION: {
    REQUIRED: "メールアドレス (確認用)" + this_required,
    INVALID: "メールアドレス (確認用)とメールアドレス確認が一致しません",
  },
  CONTENT: {
    REQUIRED: "お問い合わせ内容" + this_required,
  },
  CHECKBOX_INQUIRY: {
    REQUIRED: "同意にチェックを入れてください",
  },
  PROMOTION_SET: "参加時間は必須項目です",
};

const PREFERENC = [
  "ー",
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export { 
  DATE_FORMAT, 
  ERROR_MESSAGE, 
  SERVICE, 
  LIMIT, 
  STATUS_CODES, 
  PREFERENC 
};
